import React from 'react';
import { useQuery } from '@apollo/client';
import { ErrorMessage } from '../../../components/ErrorMessage';
import { Loader } from '../../../components/Loader';
import Navbar from '../../../components/Navbar';
import { TransferApprovalForm } from '../../../components/AssetRelocationForms/TransferApprovalForm';
import { GET_EONE_ITEM_BY_EONE_ID, GET_EONE_ITEM_BY_BARCODE } from './api';

export const EditTransferPage = (props: any) => {
  const { loading, error, data } = useQuery(GET_EONE_ITEM_BY_EONE_ID, {
    variables: {
      // id: parseInt(props.match.params.eOneId)
      id: parseInt(props.match.params.eOneId),
    },
  });
  const {
    loading: barcodeLoading,
    error: barcodeError,
    data: barcodeData,
  } = useQuery(GET_EONE_ITEM_BY_BARCODE, {
    variables: {
      barcode: props.match.params.eOneId,
    },
  });

  if (loading || barcodeLoading) {
    return (
      <div>
        <Navbar />
        <Loader />
      </div>
    );
  }
  if (error || data.readOneById === null) {
    if (barcodeError || barcodeData.findEOneByBarcode === null) {
      return (
        <div>
          <Navbar />
          <ErrorMessage title='Barcode not available: EditTransferPage/index' />;
        </div>
      );
    }
    if (barcodeData && barcodeData.findEOneByBarcode !== null) {
      return (
        <div>
          <Navbar />
          <div className='m-4'>
            <TransferApprovalForm queryData={barcodeData.findEOneByBarcode} />
          </div>
        </div>
      );
    }
    return (
      <div>
        <Navbar />
        <ErrorMessage title='Barcode not available: EditTransferPage/index' />;
      </div>
    );
  }
  if (data && data.readOneById !== null) {
    return (
      <div>
        <Navbar />
        <div className='m-4'>
          <TransferApprovalForm queryData={data.readOneById} />
        </div>
      </div>
    );
  }
};
